import {
  ClearRounded,
  EditRounded,
  RemoveRedEyeRounded,
} from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { AppContext } from "App";
import { TableActions } from "layout";
import React, { useContext } from "react";

const Actions = ({ param, handleView, handleAddEdit, handleDlt }) => {
  const { access } = useContext(AppContext);

  return (
    <TableActions>
      <Tooltip title="View Product">
        <IconButton
          onClick={() => handleView(param.id)}
          size="small"
          color="primary"
        >
          <RemoveRedEyeRounded className="!text-[18px]" />
        </IconButton>
      </Tooltip>

      {access?.catalog?.edit && (
        <Tooltip title="Edit">
          <IconButton
            onClick={() => handleAddEdit(param.id)}
            size="small"
            color="primary"
          >
            <EditRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}

      {access?.catalog?.delete && (
        <Tooltip title="Delete">
          <IconButton
            onClick={() => handleDlt(param.id)}
            size="small"
            color="error"
          >
            <ClearRounded className="!text-[18px]" />
          </IconButton>
        </Tooltip>
      )}
    </TableActions>
  );
};

export default Actions;
